import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ICommonStrings extends LocalizedStringsMethods {
    lsSelectOrgTxt: string;
    lsConfirmTxt: string;
    lsProvidedByTxt: string;
    lsName: string;
    lsFocusTxt: string;
    lsDateAndTimeTxt: string;
    lsEyeGuideInfoTxt: string;
    lsPlaceholderForTxt: string;
    lsTermsAndConditionsTxt: string;
    lsAcceptTxt: string;
    lsDeclineTxt: string;
}

let cstrings: ICommonStrings;
export default cstrings = new LocalizedStrings({
    en: {        
        lsSelectOrgTxt: 'Select an Organization',
        lsConfirmTxt: 'Confirm',
        lsProvidedByTxt: 'Provided By',
        lsDateTimeDownloadTxt: 'Date & Time Downloaded',
        lsName: 'Name',
        lsFocusTxt: 'Focus',
        lsDateAndTimeTxt: 'Date & Time',
        lsEyeGuideInfoTxt: 'INFO ABOUT EYEGUIDE\nOVERVIEW\nHOW TO INTERPRET',
        lsPlaceholderForTxt: 'PLACEHOLDER FOR',
        lsTermsAndConditionsTxt: 'Terms and Conditions',
        lsAcceptTxt: 'Accept',
        lsDeclineTxt: 'Decline'
    },
    es: {        
        lsSelectOrgTxt: 'Seleccione una organización',
        lsConfirmTxt: 'Confirmar',
        lsProvidedByTxt: 'Proporcionado por',
        lsDateTimeDownloadTxt: 'Fecha y hora descargadas',
        lsName: 'Nombre',
        lsFocusTxt: 'Atención',
        lsDateAndTimeTxt: 'Fecha y hora',
        lsEyeGuideInfoTxt: 'INFORMACIÓN SOBRE EYEGUIDE \nVISIÓN \nGENERAL CÓMO INTERPRETAR',
        lsPlaceholderForTxt: 'PLACEHOLDER PARA',
        lsTermsAndConditionsTxt: 'Terms and Conditions',
        lsAcceptTxt: 'Accept',
        lsDeclineTxt: 'Decline'     
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.common.tsx